import { render, staticRenderFns } from "./IPost.vue?vue&type=template&id=55a7e910&"
import script from "./IPost.vue?vue&type=script&lang=ts&"
export * from "./IPost.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports